import React from "react";
import { FaHome } from "react-icons/fa";
import { HighlightFeature } from "../components/Card/Cards";
import TruckImg from "../assets/images/truck.jpg"
import WhyUsImg from "../assets/images/whychooseus.png"
import Partners from "../components/Sections/Partners";
const About = () => {

  const ServicesInfo = [
    {
      icon: <FaHome className="mr-2" />,
      heading: "Safe and Secure Delivery Services",
      subHeading:
        "We ensure that all the loads that we carry are delivered to our clients safe and secure. We maintain a secured supply chain network.",
    },
    {
      icon: <FaHome className="mr-2" />,
      heading: "Commitment to Excellence",
      subHeading:
        "Our Freight Consultant and Dispatchers have expert knowledge regarding Freight movement and will give you the best advise relating to freight movement.",
    },
    {
      icon: <FaHome className="mr-2" />,
      heading: "Experienced Drivers",
      subHeading:
        "All our drivers have three plus years of experience. They go through extensive annual training. They are thorough with the routes in USA and Canada.",
    },
    {
      icon: <FaHome className="mr-2" />,
      heading: "24X7 Availability",
      subHeading:
        "We understand the needs of our Customers and this is the reason why our staff are available 24/7 to answer any of your queries or concerns with the Freight movement.",
    },
  ];
  

  return (
    <>
      <div className="py-4">
        <div className="flex align-item-center justify-content-center mb-4">
          <h1 className="text-lg lg:text-4xl">
            WELCOME TO SHAH <span className="text-red-500">TRANSPORT!</span>
          </h1>
        </div>
        <div className="flex flex-wrap lg:px-7">
          <div className="col-12 md:col-12 lg:col-6 ">
            <img
              src={TruckImg}
              alt="Shah transport"
              className="responsive"
           
            />
          </div>
          <div className="col-12 md:col-12 lg:col-6 line-height-4 py-0 my-0 ">
            <p className="py-0 my-0">
              We have been in Trucking Business for last 17 years. Our expertise
              is to move refrigerated item, general goods and fresh produce all
              over Canada and USA. We have one of the latest fleet with most of
              our power units being only two to three years old. All our drivers
              have three plus years of experience. Ensuring that the Supply
              Chain is secured at all time has been our priority ever since
              inception. We have a extensive Orientation and Recurrent program
              for the drivers. The whole team is trained on how to deal with
              unauthorized access, conveyance tampering and threat awareness.
              Shah Transport is CTPAT, PIP and CSA certified. Moving your
              freight with us means that your load is in safe hand. Our mission
              has always been to be transparent and honest with all our
              customers. Our Freight Consultant and Dispatchers have expert
              knowledge regarding Freight movement and will give you the best
              advise relating to freight movement. We understand the needs of
              our Customers and this is the reason why our staff are available
              24/7 to answer any of your queries or concerns with the Freight
              movement.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap text-white py-6">
          <div className="col-12 md:col-12 lg:col-6 bg-blue line-height-4 px-6">
            <h1 className="">Why Choose Us</h1>
            {ServicesInfo.map((data, index) => {
              return (
                <HighlightFeature
                  key={index}
                  Icon={data.icon}
                  heading={data.heading}
                  subHeading={data.subHeading}
                ></HighlightFeature>
              );
            })}
            <p className="py-0 my-0"></p>
          </div>
          <div className="col-12 md:col-12 lg:col-6 ">
            <img
              src={WhyUsImg}
              alt="Shah transport"
              className="responsive"
            />
          </div>
          <Partners/>
        </div>
      </div>
    </>
  );
};

export default About;
